import { useRepositoryQuery } from '@mews-commander/data-access';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { TableHeader, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { LedgersDatePicker } from '../../common/filters';
import { useGuestLedgerSelectedDate } from '../context/GuestLedgerFilterContext';
import { GuestLedgerTableFilters } from './GuestLedgerTableFilters';

export const GuestLedgerHeader = () => {
    const { selectedDate, setSelectedDate } = useGuestLedgerSelectedDate();
    const { data } = useRepositoryQuery('accounting', 'getEffectiveDate', {});
    return (
        <TableHeader
            title={lt('LedgersTableHeaderTitle')}
            subTitle={
                <Typography
                    textStyle="titleSmall"
                    as="span"
                    variant="tertiary"
                    data-test-id="guest-ledger-table-subtitle"
                >
                    <LocalizedDateFromUtc utcString={selectedDate} />
                </Typography>
            }
            globalSearch={{ placeholder: lt('LedgersSearchPlaceholder'), minWidth: '50%', maxCharacterCount: 120 }}
            rightSide={
                <>
                    <LedgersDatePicker
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        effectiveDate={data?.effectiveDate}
                    />
                    <GuestLedgerTableFilters />
                </>
            }
        />
    );
};
